export const stylesFooter = {
    container: {
        marginTop: 16,
        marginLeft: 10,
        fontFamily: '"Kanit", sans-serif'
    },
    listWrapper: {
        listStyle: 'none',
        padding: "0 10px",
        margin: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: '8px' // เว้นระยะห่างระหว่างแถวให้สมดุล
    },
    listItem: {
        color: "#666",
        display: 'flex',
        alignItems: 'center', // จัดให้ Tag กับ ข้อความอยู่กึ่งกลางแนวตั้งตรงกัน
        gap: '10px',
        fontSize: '11px',
        marginLeft: 8 // ปรับระยะห่างด้านซ้ายของแต่ละรายการ
    },
    tagStyle: {
        textTransform: "capitalize",
        fontWeight: "400",
        fontSize: 10,
        textAlign: 'center',
        pending: '0 8px', // เพิ่ม padding ด้านซ้ายและขวาให้ Tag
    },
    descText: {
        color: "#888"
    }
};